// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ComparablesFilterChoices__Header {
  margin-top: 0;
}
.ComparablesFilterChoices--Bold {
  font-weight: bold;
}
.ComparablesFilterChoices--MarginRight {
  margin-right: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./libs/features/feat-comparables/src/lib/comparables/comparables-filter-choices/filter-choices.component.scss"],"names":[],"mappings":"AACE;EACE,aAAA;AAAJ;AAGE;EACE,iBAAA;AADJ;AAIE;EACE,oBAAA;AAFJ","sourcesContent":[".ComparablesFilterChoices {\n  &__Header {\n    margin-top: 0;\n  }\n\n  &--Bold {\n    font-weight: bold;\n  }\n\n  &--MarginRight {\n    margin-right: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
